import { ActivityModel } from '../../../types';
import {
  AdministrationRoles,
  isAbleToSeeUIElement,
} from '../../utils/roles/client-roles';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../api/users-api';
import { Dispatch, SetStateAction } from 'react';
import SharedToolbar from '../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../shared/analytics/module-list';
import SharedIconButton from '../../shared/buttons/shared-icon-button';

interface CPanelLogsGridToolbarProps {
  administrationRoles: string[];
  handleExportMutate: () => void;
  isExporting: boolean;
  searchedLogs: ActivityModel[];
  isSearching: boolean;
  setPaginationModel: Dispatch<
    SetStateAction<{
      pageSize: number;
      page: number;
      cursor: string | null;
      startDate: number;
      endDate: number;
      actor: string;
      ip: string;
      eventName: string;
      orgUnit: string;
    }>
  >;
  beginDate: number;
  currentDate: number;
}

export default function CPanelLogsGridToolbar({
  administrationRoles,
  handleExportMutate,
  isExporting,
  searchedLogs,
  isSearching,
  setPaginationModel,
  beginDate,
  currentDate,
}: CPanelLogsGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noQuickFilter
      secondaryButtons={
        <>
          <SharedIconButton
            variant="export"
            onClick={() => handleExportMutate()}
            disabled={
              !isAbleToSeeUIElement(
                administrationRoles,
                AdministrationRoles.ExportAppLogs.value
              ) ||
              isSearching ||
              searchedLogs.length === 0
            }
            isLoading={isExporting}
            tooltipLabel="Export Results"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              setPaginationModel({
                pageSize: 50,
                page: 0,
                cursor: null,
                startDate: beginDate,
                endDate: currentDate,
                actor: '',
                ip: '',
                eventName: '',
                orgUnit: '',
              });

              queryClient.invalidateQueries({
                queryKey: [UserKeys.CPanelLogs],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="cpanelLogsGridStates"
            module={ModuleList.modules.reportCenter.name}
            section={ModuleList.modules.reportCenter.sections.cPanelLogs}
          />
        </>
      }
    />
  );
}
